import { NgModule, Optional, SkipSelf } from "@angular/core";

import { Api } from './api';
import { BtsService } from './bts.service';
import { DexieService } from "./local-data-services/dexie.service";
import { EnumService } from './enum.service';
import { GeometricDataService } from './geometric-data.service';
import { MeasureContextService } from './measure-context.service';
import { MeasureService } from './measure.service';
import { MeasureInputService } from './measure-input.service';
import { throwIfAlreadyLoaded } from "./module-import-guard";
import { ObservationService } from './observation.service';
import { ObservationTypesService } from './observation-types.service';
import { PKService } from './pk.service';
import { TabsService } from './tabs.service';
import { UpdateService } from './update.service';
import { BtLocalService } from './local-data-services/bt-local.service';
import { MeasureLocalService } from './local-data-services/measure-local.service';
import { PKLocalService } from "./local-data-services/pk-local.service";
import { UpdateLocalService } from './local-data-services/update-local.service';
import {AppInfosService} from "./app-infos.service";

@NgModule({
  providers: [
    Api,
    BtLocalService,
    BtsService,
    DexieService,
    EnumService,
    GeometricDataService,
    MeasureService,
    MeasureContextService,
    MeasureInputService,
    MeasureLocalService,
    ObservationService,
    ObservationTypesService,
    PKLocalService,
    PKService,
    TabsService,
    UpdateService,
    UpdateLocalService,
    AppInfosService
  ]
})
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts